import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useEffect } from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
// import CustomCalender from "./CustomCalender";
import useHttp from "../../../Hooks/use-http";
import "./NewBooking.css";
import { useRef } from "react";
import CustomCalender from "../../PrivateDriver/Create Shift/CustomCalender";

let corporatesData = [];
let routesData = [];
let selectedCorporateDetails = [];
let selectedRouteDetails = [];
let selecteddriverDetails = [];
let errorFields = {
  coroprateNameError: "",
  routeNameError: "",
  driverNameError: "",
  datesError: "",
};

const NewBooking = (props) => {
  const [isApiCall, setIsApiCall] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [filteredDate, setFilteredDate] = useState([]);
  const [isRouteBookingClicked, setIsRouteBookingClicked] = useState(false);
  const [isError, setIsError] = useState(errorFields);
  const corporateNameInputRef = useRef();
  const routeNameInputRef = useRef();
  const driverNameInputRef = useRef();

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const corporateNameClickHandler = (e, corporateDetails) => {
    if (corporateDetails) {
      selectedCorporateDetails = corporateDetails;
      setIsError((prev) => ({ ...prev, coroprateNameError: "" }));
      setIsApiCall(true);
    } else
      setIsError((prev) => ({ ...prev, coroprateNameError: "Invalid Field" }));
  };

  const routeNameClickHandler = (e, routeDetails) => {
    if (routeDetails) {
      setIsError((prev) => ({ ...prev, routeNameError: "" }));
      selectedRouteDetails = routeDetails;
    } else setIsError((prev) => ({ ...prev, routeNameError: "Invalid Field" }));
  };

  const driverNameClickHandler = (e, driverDetails) => {
    if (driverDetails) {
      setIsError((prev) => ({ ...prev, driverNameError: "" }));
      selecteddriverDetails = driverDetails;
    } else
      setIsError((prev) => ({ ...prev, driverNameError: "Invalid Field" }));
  };

  const handleDateRangeChange = (range, datesInRange) => {
    let filteredDates = [];

    datesInRange.forEach((date) => {
      filteredDates.push({
        BookingDate:
          date.getFullYear() +
          "/" +
          (+date.getMonth() + 1) +
          "/" +
          date.getDate(),
        Weekday: +date.getDay(),
      });
    });

    setFilteredDate(filteredDates);
    setSelectedDates(datesInRange);

    if (datesInRange.length > 0) {
      setIsError((prev) => ({ ...prev, datesError: "" }));
    }
  };

  const newBookingSubmitHandler = () => {
    if (
      corporateNameInputRef.current.value &&
      driverNameInputRef.current.value &&
      selectedDates.length > 0
    ) {
      const hasPastDates = selectedDates.some(
        (date) => date < new Date(new Date().setHours(0, 0, 0, 0))
      );

      if (hasPastDates) {
        setIsError(true);
        return;
      }

      setIsRouteBookingClicked(true);
    } else {
      if (!corporateNameInputRef.current.value)
        setIsError((prev) => ({
          ...prev,
          coroprateNameError: "Invalid Field",
        }));
      if (!routeNameInputRef.current.value)
        setIsError((prev) => ({ ...prev, routeNameError: "Invalid Field" }));
      if (!driverNameInputRef.current.value)
        setIsError((prev) => ({ ...prev, driverNameError: "Invalid Field" }));
      if (selectedDates.length === 0)
        setIsError((prev) => ({ ...prev, datesError: "Invalid Field" }));
    }
  };

  const coroprateLists = (data) => {
    let tempArr = [];
    data.corporates
      .filter((el) => el.parentID == null)
      ?.forEach((cp, i) => {
        tempArr[i] = {};
        tempArr[i].cpName = cp.name;
        tempArr[i].cpId = cp.corporateID;
      });
    corporatesData = tempArr;
  };

  const getTodayTiming = (timing) => {
    const today = new Date().getDay();
    const todayTime = timing?.find((time, index) => index === today);

    if (!todayTime) {
      return "No timing available";
    }

    const todayDate = new Date(todayTime);
    const year = todayDate.getFullYear();

    if (year === 1900) {
      return `Today: Not Scheduled`;
    }

    return `Today: ${todayDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  };

  const routeList = (data) => {
    let tempArr = [];
    data?.shuttleRoutes?.forEach((route, i) => {
      tempArr[i] = {};
      tempArr[i].routeName = route?.RouteName;
      tempArr[i].routeId = route?.RouteID;
      tempArr[i].routeTime = getTodayTiming(route?.RouteTimes);
      tempArr[i].routeType =
        route?.RouteTypeName === "Dropping" ? "dropping" : "pickup";
      tempArr[i].isDeactivated = route?.IsDeactivated;
    });
    routesData = tempArr.filter((route) => route.isDeactivated === 0);
    setIsApiCall(false);
  };

  const bookingConfirmationHandler = (data) => {
    if (data?.status == 200 || data?.status == 201) {
      props.setIsNewRouteBookingSuccess({
        status: "success",
        message: data?.message,
      });
    } else {
      props.setIsNewRouteBookingSuccess({
        status: "error",
        message: data?.message,
      });
    }
    selectedRouteDetails = [];
    props.setIsRefreshBookingList(true);
    props.setIsNewBookingClicked(false);
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    if (isRouteBookingClicked) {
      selectedRouteDetails = selectedRouteDetails.reduce((acc, cur) => {
        acc.push({
          RouteType: cur.routeType,
          RouteID: cur.routeId,
        });
        return acc;
      }, []);
      sendRequest(
        {
          url: "/createupdatebooking",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            driverEmailID: selecteddriverDetails.driverEmailId,
            routeDetails: JSON.stringify(selectedRouteDetails),
            shuttleDetails: JSON.stringify(filteredDate),
          },
        },
        bookingConfirmationHandler
      );
    }
  }, [sendRequest, isRouteBookingClicked]);

  useEffect(() => {
    if (
      (localStorage.getItem("roleId") === "1" && isApiCall) ||
      localStorage.getItem("roleId") === "2"
    )
      sendRequest(
        {
          url: "/shuttleroutes",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              filter: {
                corporateID:
                  localStorage.getItem("roleId") === "1"
                    ? selectedCorporateDetails.cpId
                    : localStorage.getItem("corpId"),
              },
            },
          },
        },
        routeList
      );
  }, [sendRequest, isApiCall]);

  useEffect(() => {
    if (localStorage.getItem("roleId") === "1")
      sendRequest(
        {
          url: "/corporates",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
          },
        },
        coroprateLists
      );
  }, [sendRequest]);

  return (
    <React.Fragment>
      {isError === true && (
        <Snackbar
          open={true}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={() => setIsError(false)}
        >
          <Alert
            severity={"error"}
            sx={{ width: "100%" }}
            onClose={() => setIsError(false)}
          >
            {"You are not allowed to do past bookings"}
          </Alert>
        </Snackbar>
      )}
      {isLoading && (
        <Backdrop
          sx={{
            color: "rgba(34, 137, 203, 255)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div
        // style={{
        //   display: "flex",
        //   justifyContent: "space-between",
        //   alignItems: "center",
        // }}
        style={{
          display: "flex",
          flexDirection: window.innerWidth <= 768 ? "column" : "row",
          justifyContent: "space-between",
          alignItems: window.innerWidth <= 768 ? "flex-start" : "center",
          gap: "10px",
          padding: window.innerWidth <= 768 ? "10px" : "0",
          flexWrap: "wrap",
        }}
      >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={corporatesData}
          // sx={{ width: 250, margin: "20px" }}
          sx={{
            width:
              window.innerWidth <= 468
                ? "100%"
                : window.innerWidth <= 768
                ? "48%"
                : 250,
            margin: window.innerWidth <= 768 ? "5px 0" : "20px",
          }}
          getOptionLabel={(data) => data.cpName}
          renderInput={(params) => (
            <TextField
              {...params}
              inputRef={corporateNameInputRef}
              error={isError.coroprateNameError}
              helperText={isError.coroprateNameError}
              variant="standard"
              placeholder="Search Corporate Name"
              label="Corporate Name"
            />
          )}
          onChange={(e, newValue) => corporateNameClickHandler(e, newValue)}
          disabled={localStorage.getItem("roleId") === "2" ? true : false}
          defaultValue={
            localStorage.getItem("roleId") === "2"
              ? { cpName: localStorage.getItem("cpName") }
              : { cpName: "" }
          }
        />
        <Autocomplete
          multiple
          disablePortal
          id="combo-box-demo"
          options={routesData}
          // sx={{ width: 250, margin: "20px" }}
          sx={{
            width:
              window.innerWidth <= 468
                ? "100%"
                : window.innerWidth <= 768
                ? "48%"
                : 250,
            margin: window.innerWidth <= 768 ? "5px 0" : "20px",
          }}
          getOptionLabel={(data) => `${data.routeName} - ${data.routeTime}`}
          renderOption={(props, data) => (
            <li {...props}>
              <span>
                {data.routeName}
                <div style={{ marginTop: "-4%" }}>
                  <span style={{ color: "gray", fontSize: "small" }}>
                    {data.routeType.charAt(0).toUpperCase() +
                      data.routeType.slice(1)}
                    {":"}
                  </span>
                  <span style={{ color: "gray", fontSize: "small" }}>
                    {" "}
                    {data.routeTime}
                  </span>
                </div>
              </span>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              inputRef={routeNameInputRef}
              error={isError.routeNameError}
              helperText={isError.routeNameError}
              variant="standard"
              placeholder="Search Route Name"
              label="Route Name"
            />
          )}
          onChange={(e, newValue) => routeNameClickHandler(e, newValue)}
        />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={props.driverListDetails}
          // sx={{ width: 250, margin: "20px" }}
          sx={{
            width:
              window.innerWidth <= 468
                ? "100%"
                : window.innerWidth <= 768
                ? "48%"
                : 250,
            margin: window.innerWidth <= 768 ? "5px 0" : "20px",
          }}
          getOptionLabel={(data) =>
            data.driverName + " (" + data.driverCarModel + ")"
          }
          renderOption={(props, data) => (
            <li {...props}>
              <span>
                {data.driverName}
                <div style={{ marginTop: "-4%" }}>
                  <span style={{ color: "gray", fontSize: "small" }}>
                    {data.driverCarModel}
                  </span>
                </div>
              </span>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              inputRef={driverNameInputRef}
              error={isError.driverNameError}
              helperText={isError.driverNameError}
              {...params}
              variant="standard"
              placeholder="Search Driver Name"
              label="Driver Name"
            />
          )}
          onChange={(e, newValue) => driverNameClickHandler(e, newValue)}
        />
        <div
          style={{
            width:
              window.innerWidth <= 468
                ? "100%"
                : window.innerWidth <= 768
                ? "48%"
                : 250,
            margin: window.innerWidth <= 768 ? "5px 0" : "20px",
          }}
        >
          <CustomCalender
            onDateRangeChange={handleDateRangeChange}
            allowDates="future"
            renderTrue={true}
            style={{ width: "250px", margin: "20px" }}
            shortcuts={[
              {
                name: "Today",
                range: () => {
                  const today = new Date();
                  return [today, today];
                },
              },
              {
                name: "Next 15 Days",
                range: () => {
                  const today = new Date();
                  const end = new Date();
                  end.setDate(today.getDate() + 14);
                  return [today, end];
                },
              },
              {
                name: "Current Month",
                range: () => {
                  const today = new Date();
                  const end = new Date(
                    today.getFullYear(),
                    today.getMonth() + 1,
                    0
                  );
                  return [today, end];
                },
              },
            ]}
          />
        </div>
      </div>
      <div
        style={{
          maxWidth: "1000px",
          padding: window.innerWidth <= 768 ? "0 10px" : "0",
        }}
      >
        {filteredDate.length > 0 && (
          <div
            style={{
              // marginLeft: "20px",
              // minWidth: "250px",
              marginLeft: window.innerWidth <= 768 ? "0" : "20px",
              maxWidth: "1000px", // or any width you want
              display: "flex",
              flexWrap: "wrap",
              gap: "6px",
            }}
          >
            Selected Dates:
            {filteredDate.map((ele, index) => (
              <span key={index} className="singleRouteBookingDate">
                {ele.BookingDate}
              </span>
            ))}
          </div>
        )}
      </div>
      <Button
        // sx={{ alignSelf: "end" }}
        sx={{
          alignSelf: "flex-end",
          margin: window.innerWidth <= 768 ? "10px" : "0",
          width: window.innerWidth <= 468 ? "100%" : "auto",
        }}
        size="small"
        color="success"
        variant="contained"
        onClick={newBookingSubmitHandler}
      >
        Add Booking
      </Button>
    </React.Fragment>
  );
};

export default NewBooking;
